import { render, staticRenderFns } from "./activityEditStudentsRegistration.html?vue&type=template&id=cd108f2c&scoped=true&external"
import script from "./activityEditStudentsRegistration.vue?vue&type=script&lang=js"
export * from "./activityEditStudentsRegistration.vue?vue&type=script&lang=js"
import style0 from "./activityEditStudentsRegistration.vue?vue&type=style&index=0&id=cd108f2c&prod&lang=css"
import style1 from "./activityEditStudentsRegistration.css?vue&type=style&index=1&id=cd108f2c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd108f2c",
  null
  
)

export default component.exports